import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import { Button } from "../../../components/shared/Button/Button";
import InteractiveSvg from "../../../components/shared/InteractiveSvg/InteractiveSvg";
import { backBodySvg } from "../../../mock/interavticeSvgs/body/backBodySvg";
import { frontBodySvg } from "../../../mock/interavticeSvgs/body/frontBodySvg";
import { useDispatch, useSelector } from "../../../redux/hooks";
import {
  setBodyPartModalData,
  setBodyPartPreviewModalData,
} from "../../../redux/slices/generatorFeaturesSlice";
import { Flex } from "../../../styled";
interface Props {
  notEditable?: boolean;
}
const BodyPartPreviewModal = ({ notEditable }: Props) => {
  const dispatch = useDispatch();
  const { bodyPartPreviewModalData: data } = useSelector(
    state => state.generatorFeaturesSlice,
  );
  const [opened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    if (data) {
      open();
    } else close();
  }, [data, close, open]);

  if (!data) return null;

  const handleClose = () => {
    dispatch(setBodyPartPreviewModalData(null));
  };

  const filteredData = data.value.filter(
    el =>
      el.type === data.selectedType && el.selectedPart === data.selectedName,
  );
  const handleEdit = () => {
    dispatch(
      setBodyPartModalData({ value: data.value, inputId: data.inputId ?? "" }),
    );
    handleClose();
  };
  return (
    <Modal onClose={handleClose} opened={opened} title={data?.selectedName}>
      <Flex justify="center">
        <InteractiveSvg
          svgFile={data?.selectedType === "front" ? frontBodySvg : backBodySvg}
          preview
          selectedParts={filteredData}
          type={data?.selectedType}
        />
      </Flex>
      {!notEditable && (
        <Flex justify="flex-end" mt={10}>
          <Button onClick={handleEdit}>Edit</Button>
        </Flex>
      )}
    </Modal>
  );
};
export default BodyPartPreviewModal;
